import axiosInstance, { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'
import convertKeys from 'utils/convert-keys'
import { ROOT, SECURE_CONSTANTS, CONSTANTS, INTERCOM_USER_HASHES } from 'resources/endpoints'

const getRoot = async () => {
  let response
  try {
    response = await axiosInstance.get(ROOT)
    if (!response) {
      throw new Error('No Response')
    }
  } catch (error) {
    error.responseJson = error.response?.data || { region: null, ipAddress: null }
    error.isNoInternetError = !error.response
    throw error
  }
  return response.data
}

const fetchSecureConstants = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(SECURE_CONSTANTS)
  return convertKeys.toCamel(response.data)
}

const fetchConstants = async () => {
  const response = await axiosInstance.get(CONSTANTS)
  return convertKeys.toCamel(response.data)
}

const fetchIntercomUserHash = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(INTERCOM_USER_HASHES)
  return convertKeys.toCamel(response.data)
}

export default {
  getRoot,
  fetchSecureConstants,
  fetchConstants,
  fetchIntercomUserHash,
}
